'use strict';

function Url(node) {
    // convert `\\` to `/`
    node.value = node.value.replace(/\\/g, '/');
}

module.exports = Url;
